import Search from "../Search/Search";
import { ReactComponent as PlusIcon } from "../../../assets/icons/Plus.svg";
import ExcelExportBtn from "../../ExcelExportBtn/ExcelExportBtn";
import { DatePick } from "../../DatePicker/DatePicker";
import { useLocation } from "react-router-dom";

const RoomPageHead = ({
  openModal,
  search,
  filter,
  searchData,
  dataSearchValues,
  DATA_SEARCH_VALUE,
}) => {
  const location = useLocation();

  return (
    <div style={{ width: "100%" }}>
      <div className="teacher-page-add-btn">
        {location.pathname === "/room" && (
          <button className="add-detail" onClick={openModal}>
            <PlusIcon />
            Əlavə et
          </button>
        )}
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        {search && location.pathname === "/room" && (
          <Search
            searchData={searchData}
            dataSearchValues={dataSearchValues}
            className="search-input-con desktop"
            DATA_SEARCH_VALUE={DATA_SEARCH_VALUE}
          />
        )}

        {location.pathname === "/room/calendar" && (
          <DatePick deviceType="desktop" />
        )}

        <div className="lesson-table-btn-container teacher ">
          <button className="add-detail" onClick={() => filter()}>
            Tətbiq et
          </button>
        </div>

        <ExcelExportBtn pageName="room" />
      </div>
    </div>
  );
};

export default RoomPageHead;
